import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, TextField, Typography } from '@mui/material';
import { useController } from 'react-hook-form';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import { PageStatusCircle } from '@/components/PageStatusCircle';
import SettingsInputContainer from '../../components/SettingsInputContainer';
import Container from '../../components/Container';
import M24PageFinder from '../../components/Finder/M24PageFinder/M24PageFinder';
import { Page } from '../../declarations/models/Page';
import { Site } from '../../declarations/models/Site';
import Styles from '../../assets/js/Styles';
import DeleteButton from '../../components/DeleteButton';

export const LanguageKeypagesSettings: FC = () => {
  const { t } = useTranslation('components');
  const [pageFinderOpen, setPageFinderOpen] = useState<boolean>(false);

  const {
    field: { value: dmFilterPage, onChange: onChangeDmFilterPage },
  } = useController<Site, `content.settings.dmFilterPage`>({
    name: `content.settings.dmFilterPage`,
  });

  const handleOnChangeDmFilterPage = (item: Page) => {
    onChangeDmFilterPage(item);
  };

  return (
    <>
      <SettingsInputContainer title={t('Settings.LanguageSettings.keypages.dmFilterPage')} anchor='keypages'>
        <Container fullWidth column gap={2} left>
          <M24PageFinder
            hideSiteSelector
            open={pageFinderOpen}
            onClose={() => setPageFinderOpen(false)}
            onSelectionConfirmed={(pages) => {
              if (pages.length) {
                handleOnChangeDmFilterPage(pages[0].source);
              }
            }}
          />
          <Typography variant='caption'>{t('Settings.LanguageSettings.keypages.dmFilterPageInfo')}</Typography>

          {dmFilterPage && (
            <Container
              px={2}
              fullWidth
              spaceBetween
              sx={{
                backgroundColor: Styles.Colors.THEME_BG_COLOR_SECONDARY,
                borderRadius: Styles.Dimensions.RADIUS_ROUNDNESS_DEFAULT,
                height: '50px',
              }}>
              <Container>
                <PageStatusCircle status={dmFilterPage.status} size={20} />
                <Typography>{dmFilterPage.title}</Typography>
                <Typography
                  variant='caption'
                  sx={{ px: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {dmFilterPage.path || dmFilterPage.url}
                </Typography>
              </Container>
              <DeleteButton
                onConfirm={() => onChangeDmFilterPage(null)}
                deleteLabel='remove'
                deleteIcon={<MaterialSymbol name='do_not_disturb_on' />}
              />
            </Container>
          )}

          <Button
            variant='contained'
            color='secondary'
            sx={{ flex: '1 0 auto' }}
            onClick={() => setPageFinderOpen(true)}>
            {t(`Settings.LanguageSettings.404.addPageButton`)}
          </Button>
        </Container>
      </SettingsInputContainer>
    </>
  );
};

export default LanguageKeypagesSettings;
